import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import FileRow from "../../../configuration/shared/FileRow/FileRow";
import ButtonRow from "../../../configuration/shared/ButtonRow/ButtonRow";
import CheckboxRow from "../../../configuration/shared/CheckboxRow/CheckboxRow";
import axios from "../../../../axios";


class InvoiceModal extends Component {

  state = {
    invoice: {},
    status: { "Sent to Poisson": false, "Invoice paid": false },
    uploadFile: null,
    valuesChanged: false,
    selectedFileName: null,
    xmlFileName: null,
    embeddedPDF: null,
    xmlUploaded: false,
    parsingXML: false,
  }

  componentDidMount() {
    let invoice = this.props.selectedInvoice
    
    // Create an invoice if necessary
    if (invoice === null) {

      invoice = { 
        description: "",
        supplier: "",
        sentToAccountant: false, 
        paid: false,
        invoiceDate: new Date() / 1000,
        invoiceIndex: this.props.proposedIndex
      }
    }
    // Change dot to comma
    if (invoice.amountWithoutVAT) {
      invoice.amountWithoutVAT = invoice.amountWithoutVAT.toLocaleString("be-NL")
    }
    // Change dot to comma for vatAmount
    if (invoice.vatAmount) {
      invoice.vatAmount = invoice.vatAmount.toLocaleString("be-NL")
    }
    // Parse date
    if (invoice.invoiceDate) {
      invoice.invoiceDate = new Date(invoice.invoiceDate * 1000).toLocaleDateString("en-GB")
    }

    this.setState({ 
      invoice: {...invoice},
      status: { "Sent to Poisson": invoice.sentToAccountant, "Invoice paid": invoice.paid }
    })
  }

  deleteHandler = () => {
    // Sync to the backend
    axios.delete("/invoices/delete/" + this.state.invoice._id)
    // Close the modal view
    this.props.closeModal()
  }

  saveInvoiceHandler = () => {

    // Parse additional properties into invoice
    let invoice = this.state.invoice
    invoice.sentToAccountant = this.state.status["Sent to Poisson"]
    invoice.paid = this.state.status["Invoice paid"]
    invoice.amountWithoutVAT = invoice.amountWithoutVAT ? invoice.amountWithoutVAT.replace(/,/g, '.') : null
    invoice.vatAmount = invoice.vatAmount ? invoice.vatAmount.replace(/,/g, '.') : null

    // Convert European date to JavaScript date
    var parts = invoice.invoiceDate ? invoice.invoiceDate.split("/") : []
    if (parts.length === 3) {
      var date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
      invoice.invoiceDate = date.getTime() / 1000
    } else {
      invoice.invoiceDate = 0
    }

    // Sync to the backend
    if (this.state.valuesChanged) {
      axios.post("/invoices/update/aankoop", this.state.invoice)
    }

    // Close the modal view
    this.props.closeModal()
  }

  /**
   * Parse purchase invoice filename to extract supplier and date
   * Expected format: "INDEX SUPPLIER DD-MM-YYYY" or "INDEX - SUPPLIER DD-MM-YYYY"
   * (e.g., "1 Apple 05-01-2026" or "1 - Apple 05-01-2026")
   */
  parsePurchaseFilename = (filename) => {
    try {
      // Remove .pdf extension
      const baseName = filename.replace(/\.pdf$/i, '').trim()
      
      // Match pattern: INDEX SUPPLIER DD-MM-YYYY (with optional dash after index)
      const match = baseName.match(/^(\d+)\s+(?:-\s+)?(.+?)\s+(\d{1,2}-\d{1,2}-\d{4})(?:\s*\(\d+\))?$/)
      
      if (match) {
        const [, filenameIndex, supplier, dateStr] = match
        
        // Parse date from DD-MM-YYYY to DD/MM/YYYY format
        const dateParts = dateStr.split('-')
        const invoiceDate = `${dateParts[0].padStart(2, '0')}/${dateParts[1].padStart(2, '0')}/${dateParts[2]}`
        
        return {
          filenameIndex: parseInt(filenameIndex, 10),
          supplier: supplier.trim(),
          invoiceDate
        }
      }
    } catch (e) {
      console.warn('Could not parse purchase invoice filename:', filename, e)
    }
    return null
  }

  uploadPDF = (event, thisRef) => {
    const file = event.target.files[0]
    if (!file) return

    // Track the selected filename for visual feedback
    thisRef.setState({ selectedFileName: file.name })

    // In create mode, try to parse filename for autofill
    const createMode = thisRef.props.selectedInvoice === null
    
    if (createMode) {
      const parsed = thisRef.parsePurchaseFilename(file.name)
      
      if (parsed) {
        // Check if filename index matches proposed index
        if (parsed.filenameIndex !== thisRef.props.proposedIndex) {
          alert(`Warning: Filename index (${parsed.filenameIndex}) does not match the proposed invoice number (${thisRef.props.proposedIndex}).`)
        }
        
        // Autofill supplier and invoice date (user can still edit)
        thisRef.setState(prevState => ({
          invoice: {
            ...prevState.invoice,
            supplier: parsed.supplier,
            invoiceDate: parsed.invoiceDate
          },
          valuesChanged: true
        }))
      }
    }

    // Read the file's contents
    var reader = new FileReader();
    reader.addEventListener("load", function() {
      // Save uploaded PDF
      let pdfContent = reader.result.split("base64,")[1]
      thisRef.updateProperty("pdfContent", pdfContent)
    })
    reader.readAsDataURL(file)
  }

  downloadPDFhandler = () => {

    // Request the PDF from the backend first (lazy fetch)
    axios.get("/invoices/pdf/" + this.state.invoice._id).then(response => {
      if (response.data) {

        if (response.data.pdfContent) {
          // Download PDF file
          const fileName = this.state.invoice.invoiceIndex + " " + this.state.invoice.supplier + " " + this.state.invoice.invoiceDate.replace(/\//g, '-') + ".pdf"
          const href = "data:application/pdf;base64," + response.data.pdfContent
          const link = document.createElement("a")
          link.href = href
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          return 

        } 
      }
      alert("No PDF file was attached to this invoice entry.")

    }).catch((err) => {
      alert("Could not download invoice: " + err.message)
    })
  }

// Upload and parse XML e-invoice

  uploadXML = (event, thisRef) => {
    const file = event.target.files[0]
    if (!file) return

    thisRef.setState({ 
      xmlFileName: file.name,
      parsingXML: true 
    })

    // Read XML file content
    const reader = new FileReader()
    reader.addEventListener("load", function() {
      const xmlContent = reader.result
      
      // Send to backend for parsing
      axios.post("/invoices/parse-xml", { xmlContent })
        .then(response => {
          const data = response.data
          
          // Format invoice date from Unix timestamp to DD/MM/YYYY
          let invoiceDate = null
          if (data.invoiceDate) {
            const date = new Date(data.invoiceDate * 1000)
            invoiceDate = date.toLocaleDateString("en-GB")
          }
          
          // Format amounts with comma
          const amountWithoutVAT = data.amountWithoutVAT 
            ? data.amountWithoutVAT.toLocaleString("be-NL") 
            : null
          const vatAmount = data.vatAmount 
            ? data.vatAmount.toLocaleString("be-NL") 
            : null
          
          // Update invoice with parsed data
          thisRef.setState(prevState => ({
            invoice: {
              ...prevState.invoice,
              supplier: data.supplier || prevState.invoice.supplier,
              invoiceDate: invoiceDate || prevState.invoice.invoiceDate,
              amountWithoutVAT: amountWithoutVAT || prevState.invoice.amountWithoutVAT,
              vatAmount: vatAmount || prevState.invoice.vatAmount,
              // Store embedded PDF as the invoice's PDF content
              pdfContent: data.embeddedPDF || prevState.invoice.pdfContent,
            },
            embeddedPDF: data.embeddedPDF,
            xmlUploaded: true,
            parsingXML: false,
            valuesChanged: true,
          }))
          
        })
        .catch(err => {
          thisRef.setState({ parsingXML: false })
          alert("Failed to parse XML e-invoice: " + (err.response?.data?.message || err.message))
        })
    })
    reader.readAsText(file)
  }

//  Download the embedded PDF from the parsed XML

  downloadEmbeddedPDFHandler = () => {
    if (!this.state.embeddedPDF) {
      alert("No embedded PDF available in this e-invoice.")
      return
    }

    // Generate filename from invoice data
    const supplier = this.state.invoice.supplier || "invoice"
    const date = this.state.invoice.invoiceDate?.replace(/\//g, '-') || ""
    const index = this.state.invoice.invoiceIndex || ""
    const filename = `${index} ${supplier} ${date}.pdf`.trim().replace(/\s+/g, ' ')

    // Use backend endpoint to download PDF
    axios.post("/invoices/download-embedded-pdf", {
      pdfBase64: this.state.embeddedPDF,
      filename
    }, {
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement("a")
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }).catch(err => {
      alert("Could not download PDF: " + (err.response?.data?.message || err.message))
    })
  }

  updateProperty(property, value) {
    let invoice = {...this.state.invoice}
    invoice[property] = value
    this.setState({ invoice: invoice, valuesChanged: true })
  }


  render() {

    let createMode = (this.props.selectedInvoice === null)

    // Calculate total amount locally (amountWithoutVAT + vatAmount)
    let showTotal = false
    let totalAmount = 0
    const amountWithoutVATStr = this.state.invoice.amountWithoutVAT?.toString().replace(/,/g, '.') ?? ''
    const vatAmountStr = this.state.invoice.vatAmount?.toString().replace(/,/g, '.') ?? ''
    const numericWithoutVAT = parseFloat(amountWithoutVATStr)
    const numericVAT = parseFloat(vatAmountStr)
    
    if (!isNaN(numericWithoutVAT) || !isNaN(numericVAT)) {
      totalAmount = (isNaN(numericWithoutVAT) ? 0 : numericWithoutVAT) + (isNaN(numericVAT) ? 0 : numericVAT)
      showTotal = true
    }


    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "Upload new purchase" : "Edit purchase"}
      >
        <InputRow
          title="Supplier"
          enabled
          ultrawide
          firstRow
          value={this.state.invoice.supplier ?? ""}
          placeholder={"E.g. Siemens"}
          onChange={(event) => this.updateProperty("supplier", event.target.value)}/>
        <InputRow
          title="Description"
          enabled
          ultrawide
          value={this.state.invoice.description ?? ""}
          placeholder={"E.g. IOT2050 hardware"}
          onChange={(event) => this.updateProperty("description", event.target.value)}/>
        <InputRow
          title="Invoice number"
          enabled
          ultrawide
          value={this.state.invoice.invoiceIndex ?? ""}
          placeholder={"E.g. 5"}
          onChange={(event) => this.updateProperty("invoiceIndex", event.target.value)}/>
        <InputRow
          title="Invoice date"
          enabled
          ultrawide
          value={this.state.invoice.invoiceDate ?? ""}
          placeholder={"E.g. 15/01/2024"}
          onChange={(event) => this.updateProperty("invoiceDate", event.target.value)}/>
        <InputRow
          title="Amount excl. VAT"
          enabled
          ultrawide
          value={this.state.invoice.amountWithoutVAT ?? ""}
          placeholder={"Amount"}
          onChange={(event) => this.updateProperty("amountWithoutVAT", event.target.value)}/>
        <InputRow
          title="VAT amount"
          enabled
          ultrawide
          value={this.state.invoice.vatAmount ?? ""}
          placeholder={"VAT amount"}
          onChange={(event) => this.updateProperty("vatAmount", event.target.value)}/>
        {showTotal &&
        <InputRow
          title="Total invoice amount"
          enabled={false}
          ultrawide
          value={"€ " + totalAmount.toLocaleString("de-DE")}/>}
        <CheckboxRow
          title="Status"
          options={this.state.status}
          optionChanged={(option, checked) => {
            let status = {...this.state.status}
            status[option] = checked
            this.setState({ status: status, valuesChanged: true })
          }}/> 

        {!createMode &&
        <ButtonRow
          title="Download invoice PDF"
          ultrawide
          body="Download .pdf file"
          onClick={this.downloadPDFhandler}/>}

        {/* XML e-invoice upload (create mode only) */}
        {createMode && (
          <FileRow
            title="Upload XML e-invoice"
            body={this.state.parsingXML ? "Parsing..." : "Choose .xml file"}
            inputId="purchaseInvoiceXmlInput"
            selectedFileName={this.state.xmlFileName}
            onClick={(xml) => this.uploadXML(xml, this)}
            extension=".xml"/>
        )}

        {/* Download embedded PDF from XML */}
        {createMode && this.state.embeddedPDF && (
          <ButtonRow
            title="Embedded PDF"
            body="Download PDF from e-invoice"
            onClick={this.downloadEmbeddedPDFHandler}/>
        )}

        {/* PDF upload - disabled when XML with embedded PDF is uploaded */}
        {!this.state.embeddedPDF && (
          <FileRow
            title={createMode ? "Upload invoice PDF" : "Replace invoice PDF"}
            body={"Choose .pdf file"}
            inputId="purchaseInvoicePdfInput"
            selectedFileName={this.state.selectedFileName}
            onClick={(pdf) => this.uploadPDF(pdf, this)}
            extension=".pdf"/>
        )}
        
        <ModalActions>
          {(this.state.valuesChanged || createMode) ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.saveInvoiceHandler}>
                {createMode ? "Upload" : "Save"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.saveInvoiceHandler}>Close</CancelButton>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default InvoiceModal;
